export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";
export const SET_CUSTOM_DIALOG_PROPS = "NOTIFICATIONS/SET_CUSTOM_DIALOG_PROPS";
